/*
  Filtrage de la galerie produit par coloris.

  Chaque image porte un attribut data-media-group calcule en Liquid a partir de
  son texte alternatif (voir snippets/media-group.liquid). Au changement de
  variante, les images des autres coloris sont RETIREES du carrousel, puis
  remises quand on revient sur le coloris.

  Cinq pieges rencontres, et leur reponse :

  1. Masquer en display:none ne suffit pas : Swiper continue de compter les
     diapositives masquees et reste positionne sur une image invisible.
     Les images sont donc retirees physiquement du DOM.

  2. Une simple mise a jour du carrousel ne suffit pas non plus : les images
     restantes se superposent. Le carrousel est reconstruit.

  3. product-info.js appelle init() PUIS setActiveMedia() a chaque changement
     de variante. Reappliquer le coloris initial du serveur dans init()
     annulait le filtrage. Le coloris initial n'est applique qu'une fois.

  4. product-info.js interroge la galerie des son propre chargement, parfois
     avant que les images soient analysees par le navigateur. Un inventaire
     vide n'est jamais conserve.

  5. Le theme n'affiche que les premieres images (data-initial-media-limit) et
     garde les suivantes dans un <template>. Un inventaire pris trop tot etait
     donc INCOMPLET : 10 images retenues sur 16, d'ou un melange de coloris.
     L'inventaire charge desormais les images differees avant de compter, et
     n'est fige que s'il atteint data-total-media-count.

  Aucun fichier d'origine du theme n'est modifie : les methodes sont greffees
  sur le prototype de <media-gallery> apres sa definition. En cas d'echec, le
  comportement d'origine reprend la main.
*/
(function () {
  function norm(value) {
    return String(value === null || value === undefined ? '' : value).trim().toLowerCase();
  }

  function patch() {
    var MediaGallery = customElements.get('media-gallery');
    if (!MediaGallery) return false;

    var proto = MediaGallery.prototype;
    if (proto.__variantMediaFilter) return true;
    proto.__variantMediaFilter = true;
    window.__variantMediaFilterInstalled = true;

    proto.vmfWrapper = function () {
      return this.querySelector('[id^="Slider-Gallery"]');
    };

    proto.vmfThumbsWrapper = function () {
      return this.querySelector('[id^="Slider-Thumbnails"]');
    };

    proto.vmfExpectedCount = function () {
      var n = parseInt(this.dataset.totalMediaCount, 10);
      return isNaN(n) ? 0 : n;
    };

    proto.vmfSnapshotReady = function () {
      if (!this._vmfSlides || !this._vmfSlides.length) return false;
      var expected = this.vmfExpectedCount();
      return !expected || this._vmfSlides.length >= expected;
    };

    // L'inventaire n'est fige que s'il est complet. Ni vide, ni tronque.
    proto.vmfSnapshot = function () {
      if (this.vmfSnapshotReady()) return;

      if (typeof this.ensureDeferredLoaded === 'function') {
        try { this.ensureDeferredLoaded(); } catch (e) {}
      }

      var wrapper = this.vmfWrapper();
      if (!wrapper) return;

      var slides = Array.prototype.slice.call(wrapper.querySelectorAll('.product__media-item'));
      if (!slides.length) return;

      var expected = this.vmfExpectedCount();
      if (expected && slides.length < expected) return;

      slides.sort(function (a, b) {
        var ia = parseInt(a.dataset.mediaIndex, 10);
        var ib = parseInt(b.dataset.mediaIndex, 10);
        if (isNaN(ia) || isNaN(ib)) return 0;
        return ia - ib;
      });

      this._vmfSlides = slides;

      var thumbsWrapper = this.vmfThumbsWrapper();
      this._vmfThumbs = thumbsWrapper
        ? Array.prototype.slice.call(thumbsWrapper.querySelectorAll('.product__thumbs-item'))
        : [];

      if (!this._vmfStore) this._vmfStore = document.createDocumentFragment();
    };

    proto.vmfGroups = function () {
      var out = [];
      (this._vmfSlides || []).forEach(function (slide) {
        var group = slide.dataset.mediaGroup;
        if (group && out.indexOf(group) === -1) out.push(group);
      });
      return out;
    };

    proto.vmfGroupForVariant = function (variant) {
      if (!variant) return null;
      this.vmfSnapshot();
      var groups = this.vmfGroups();
      if (!groups.length) return null;
      var options = (variant.options || []).map(norm);
      var found = null;
      groups.forEach(function (group) {
        if (options.indexOf(norm(group)) !== -1) found = group;
      });
      return found;
    };

    proto.vmfRebuildSlider = function () {
      if (!this.sliderInstance || !this.sliderInstance.slider) return;

      try { this.sliderInstance.slider.destroy(true, true); } catch (e) {}
      this.sliderInstance = false;

      if (this.thumbsInstance && this.thumbsInstance.slider) {
        try { this.thumbsInstance.slider.destroy(true, true); } catch (e) {}
        this.thumbsInstance = false;
      }

      try { this.initSlider(); } catch (e) {}

      try {
        var slider = this.sliderInstance && this.sliderInstance.slider;
        if (slider && !slider.destroyed) {
          slider.update();
          if (slider.pagination && typeof slider.pagination.render === 'function') {
            slider.pagination.render();
            slider.pagination.update();
          }
        }
      } catch (e) {}
    };

    proto.vmfApply = function (group, variant) {
      if (!group) return false;
      this.vmfSnapshot();
      if (!this.vmfSnapshotReady()) return false;

      var wrapper = this.vmfWrapper();
      if (!wrapper) return false;

      var target = norm(group);
      var known = false;
      this.vmfGroups().forEach(function (value) {
        if (norm(value) === target) known = true;
      });
      if (!known) return false;

      var matches = this._vmfSlides.filter(function (slide) {
        var slideGroup = slide.dataset.mediaGroup;
        return !slideGroup || norm(slideGroup) === target;
      });
      if (!matches.length) return false;

      var store = this._vmfStore;

      this._vmfSlides.forEach(function (slide) {
        slide.style.display = '';
        slide.removeAttribute('aria-hidden');
        wrapper.appendChild(slide);
      });
      this._vmfSlides.forEach(function (slide) {
        if (matches.indexOf(slide) === -1) store.appendChild(slide);
      });

      var featuredId = variant && variant.featured_media && variant.featured_media.id
        ? String(variant.featured_media.id)
        : null;

      if (featuredId) {
        for (var i = 0; i < matches.length; i++) {
          if (String(matches[i].dataset.mediaId) === featuredId) {
            wrapper.insertBefore(matches[i], wrapper.firstChild);
            break;
          }
        }
      }

      var thumbsWrapper = this.vmfThumbsWrapper();
      if (thumbsWrapper && this._vmfThumbs && this._vmfThumbs.length) {
        var thumbMatches = this._vmfThumbs.filter(function (thumb) {
          var thumbGroup = thumb.dataset.mediaGroup;
          return !thumbGroup || norm(thumbGroup) === target;
        });
        if (thumbMatches.length) {
          this._vmfThumbs.forEach(function (thumb) {
            thumb.style.display = '';
            thumbsWrapper.appendChild(thumb);
          });
          this._vmfThumbs.forEach(function (thumb) {
            if (thumbMatches.indexOf(thumb) === -1) store.appendChild(thumb);
          });
          if (featuredId) {
            for (var j = 0; j < thumbMatches.length; j++) {
              if (String(thumbMatches[j].dataset.target) === featuredId) {
                thumbsWrapper.insertBefore(thumbMatches[j], thumbsWrapper.firstChild);
                break;
              }
            }
          }
        }
      }

      this._vmfCurrent = target;

      if (this.elements) {
        this.elements.mediaItems = Array.prototype.slice.call(
          wrapper.querySelectorAll('.product__media-item')
        );
      }

      var self = this;
      window.requestAnimationFrame(function () {
        self.vmfRebuildSlider();
        if (self.enableImageZoom && typeof self.initImageZoom === 'function') {
          try {
            self.initImageZoom(Array.prototype.slice.call(wrapper.querySelectorAll('.product__media-item')));
          } catch (e) {}
        }
      });

      return true;
    };

    var originalSetActiveMedia = proto.setActiveMedia;
    proto.setActiveMedia = function (variant) {
      var group = this.vmfGroupForVariant(variant);
      if (group && this.vmfApply(group, variant)) return;
      if (typeof originalSetActiveMedia === 'function') {
        return originalSetActiveMedia.call(this, variant);
      }
    };

    // Le coloris initial n'est applique qu'une fois, et seulement quand
    // l'inventaire des photos est complet. On reessaie le temps que les
    // images differees arrivent.
    proto.vmfApplyInitialOnce = function () {
      if (this._vmfInitApplied) return true;
      var initial = this.dataset.initialMediaGroup;
      if (!initial) {
        this._vmfInitApplied = true;
        return true;
      }
      this.vmfSnapshot();
      if (!this.vmfSnapshotReady()) return false;
      this._vmfInitApplied = true;
      this.vmfApply(initial, null);
      return true;
    };

    var originalInit = proto.init;
    proto.init = function () {
      var result = originalInit.apply(this, arguments);
      var self = this;
      var tries = 0;
      var tick = function () {
        if (self.vmfApplyInitialOnce()) return;
        tries += 1;
        if (tries < 40) window.setTimeout(tick, 100);
      };
      window.requestAnimationFrame(tick);
      return result;
    };

    document.querySelectorAll('media-gallery').forEach(function (element) {
      if (element.initialized) element.vmfApplyInitialOnce();
    });

    return true;
  }

  if (!patch()) {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (patch() || attempts > 60) window.clearInterval(timer);
    }, 100);
  }
})();
